export default {
  install(Vue) {
    Vue.directive('numberOnly', {
      bind(el) {
        el.addEventListener('keyup', () => {
          let regex = /^[0-9.]*$/

          if (!regex.test(el.value)) {
            el.value = el.value.slice(0, -1)
            // for antd type number
            const antNumber = document.querySelector(
              `#${el.id} .ant-input-number-input`,
            )
            if (antNumber) antNumber.value = el.value
            //
          }
        })
      },
    })

    Vue.directive('numberAnddot', {
      bind(el) {
        el.addEventListener('keyup', () => {
          let regex = /^[0-9:.]*$/

          if (!regex.test(el.value)) {
            el.value = el.value.slice(0, -10)
          }
        })
      },
    })

    Vue.directive('englishNumberOnly', {
      bind(el) {
        el.addEventListener('keyup', () => {
          let regex = /^[0-9a-zA-Z]+$/
          if (!regex.test(el.value)) {
            el.value = el.value.slice(0, -1)
          }
        })
      },
    })
    Vue.directive('lowercase', {
      bind(el) {
        el.addEventListener('keyup', () => {
          el.value = el.value.toLowerCase()
        })
      },
    })
    Vue.directive('noneSpecial', {
      bind(el) {
        el.addEventListener('keyup', () => {
          let regex = /^[ก-๙0-9a-zA-Z]+$/
          if (!regex.test(el.value)) {
            el.value = el.value.slice(0, -1)
          }
        })
      },
    })
    Vue.directive('maxchars', {
      bind(el, binding) {
        var max_chars = binding.value
        var handler = e => {
          if (e.target.value.length > max_chars) {
            e.target.value = e.target.value.substr(0, max_chars)
          }
        }
        el.addEventListener('input', handler)
      },
    })
    Vue.directive('maxvalue', {
      bind(el, binding) {
        var max_value = binding.expression
        var handler = e => {
          if (parseInt(e.target.value) > parseInt(max_value)) {
            e.target.value = max_value
          }
        }
        el.addEventListener('input', handler)
      },
    })
    Vue.directive('minvalue', {
      bind(el, binding) {
        var min_value = binding.expression
        var handler = e => {
          if (parseInt(e.target.value) < parseInt(min_value)) {
            e.target.value = min_value
          }
        }
        el.addEventListener('input', handler)
      },
    })
 
  },
}
